import { AvailableLanguages } from '@repo/toolkit/language-types'
import { getLocale } from '@repo/toolkit/locale'
import { useTranslation } from 'react-i18next'

const useTranslate = () => {
  const { t, i18n } = useTranslation<AvailableLanguages>()

  const currentLanguage = i18n.language as AvailableLanguages

  return { t, i18n, getLocale: () => getLocale(currentLanguage), currentLanguage }
}

export default useTranslate
